import React from 'react';
import { Icon } from './Icon.js';
export const IconBallotCircleFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M10.5,6h4.75c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75h-4.75c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M15.25,12h-4.75c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75h4.75c.414,0,.75-.336,.75-.75s-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "5", cy: "5", r: "3", fill: "currentColor" }),
        React.createElement("circle", { cx: "5", cy: "13", r: "3", fill: "currentColor" })));
};
//# sourceMappingURL=IconBallotCircleFill18.js.map